// Перевод СООБЩЕНИЙ ОБ ОШИБКАХ, которые приходят с сервера (`detail` у 4xx). Бэк отвечает по-русски:
// он не знает языка игрока (одни и те же строки летят и в сокет, и в REST, и в админку), поэтому
// перевод — на клиенте, ключ = исходная русская строка. Незнакомое сообщение показываем КАК ЕСТЬ,
// иначе новая серверная ошибка превратилась бы в пустую плашку.
//
// Покрыт контур ежедневных заданий и расходников (задания/сундуки/почта/лавка/автоподбор/минуты/эфир):
// именно эти ошибки игрок видит в обычной игре. Добавляя серверную ошибку в этот контур — добавь строку
// сюда и ключ в `locales/*.js` (секция `srvError`).
import { t } from './index';

const MAP = {
  // задания дня
  'Почва иссушает ресурсы Короля — навык недоступен': 'srvError.soilDrains',
  // отказы, заведённые аудитом 2026-08-31 (ход на занятую клетку, цель атаки, цена навыка в здоровье)
  'Клетка занята — атакуйте фигуру': 'srvError.cellTaken',
  'Цель вне боя': 'srvError.targetNotInFight',
  'Атаковать можно только фигуру соперника': 'srvError.targetIsAlly',
  'Недостаточно здоровья для навыка': 'srvError.noHealthForSkill',
  'Задание не найдено': 'srvError.questNotFound',
  'Задание прошлого дня': 'srvError.questOldDay',
  'Задание ещё не выполнено': 'srvError.questNotDone',
  'Награда уже получена': 'srvError.rewardTaken',
  'Бесплатная замена на сегодня использована': 'srvError.rerollUsed',
  'Нет другого задания этой сложности': 'srvError.noOtherQuest',
  // сундук / почта / выбор предмета
  'Сундук дня ещё не открыт': 'srvError.chestNotReady',
  'Сундук дня уже получен': 'srvError.chestTaken',
  'Письмо не найдено': 'srvError.mailNotFound',
  'Выбор недоступен': 'srvError.choiceUnavailable',
  'Нет свободного места — освободите ячейку': 'srvError.noSpace',
  'Сундук полон': 'srvError.chestFull',
  // вход и создание аккаунта (волна 5.1: у пароля появились требования — игрок обязан видеть, какие)
  'Это имя занято': 'srvError.nameTaken',
  'Пароль не может состоять из одних пробелов': 'srvError.pwdBlank',
  'Неверный текущий пароль': 'srvError.pwdWrongCurrent',
  'Новый пароль совпадает со старым': 'srvError.pwdSameAsOld',
  'Пароль не должен совпадать с именем игрока': 'srvError.pwdSameAsName',
  // ограничение частоты запросов (429): сервер отвечает так при слишком частых обращениях
  'Слишком много запросов, повторите позже': 'srvError.tooManyRequests',
  // лавка расходников
  'Недостаточно материалов': 'srvError.noMaterials',
  'Недостаточно самоцветов': 'srvError.noGems',
  'Неизвестный свиток': 'srvError.unknownScroll',
  'Некорректное количество': 'srvError.badCount',
  'Некорректное количество минут': 'srvError.badMinutes',
  // расходники
  'Нет минут ускорения': 'srvError.noMinutes',
  'Нет эфира зарядов': 'srvError.noEther',
  'Нет свитка подмастерья': 'srvError.noApprenticeScroll',
  'Нет свитка мастера': 'srvError.noMasterScroll',
  'Заряды уже полные': 'srvError.chargesFull',
  // аренда NFT-фигур (`apps/web3/rent.py`): экран `/rent` и отказы «Настроек фигур» по чужой фигуре.
  // 🔴 Без этих строк английская локаль показывала игроку РУССКИЙ текст сервера — а других слов у
  // отказа нет: экран печатает `detail` как есть (аудит 2026-09-13).
  'Это предложение уже недоступно': 'srvError.rentOfferGone',
  'Нельзя взять в аренду свою же фигуру': 'srvError.rentOwnFigure',
  'Этой фигуры больше нет у владельца': 'srvError.rentFigureGone',
  'Владелец изменил условия — обновите витрину': 'srvError.rentTermsChanged',
  'Фигура восстанавливается — попробуйте позже': 'srvError.rentFigureHealing',
  'Фигура выставлена на продажу в блокчейне — снимите лот': 'srvError.rentFigureListed',
  'В аренду сдаётся только фигура с запечённым комплектом': 'srvError.rentNeedsBaked',
  'В аренду сдаются только NFT-воины': 'srvError.rentNftOnly',
  'В турнире аренда фигур недоступна': 'srvError.rentNoSeason',
  'Идёт партия — попробуйте после её окончания': 'srvError.rentInMatch',
  'Аренда между связанными аккаунтами недоступна': 'srvError.rentSelfDeal',
  'Аренда за фиксированную плату досрочно не возвращается — дождитесь конца срока': 'srvError.rentNoEarlyReturn',
  'Сначала восстановите фигуру — она возвращается владельцу целой': 'srvError.rentReturnHealthy',
  'Сначала выведите фигуру из боевого состава': 'srvError.rentLeaveSquad',
  'Фигура уже отозвана и вернётся после партии арендатора': 'srvError.rentAlreadyRecalled',
  'Эта аренда уже закрыта': 'srvError.rentClosed',
  'Эта фигура уже в аренде': 'srvError.rentAlreadyRented',
  'Эта фигура уже выставлена в аренду': 'srvError.rentAlreadyOffered',
  'Эта фигура уже сдана': 'srvError.rentAlreadyLent',
  'Эта фигура выставлена в аренду — сначала снимите предложение': 'srvError.rentUnlistFirst',
  'Фигура взята в аренду — её амуницию меняет только собственник': 'srvError.rentGearLocked',
  'Фигура сдана в аренду': 'srvError.rentLent',
  'Фигура сдана в аренду — сначала верните её владельцу': 'srvError.rentReturnFirst',
  'Условия уже принятой аренды не меняются': 'srvError.rentTermsLocked',
  'Срок этого предложения истёк': 'srvError.rentOfferExpired',
  'Предложение не найдено': 'srvError.rentOfferNotFound',
  'Аренда не найдена': 'srvError.rentNotFound',
  'Это предложение уже снято': 'srvError.rentOfferCancelled',
  'Выберите одну плату: за сутки ИЛИ процент от заработка': 'srvError.rentOnePayment',
  'Процент — от 1 до 100': 'srvError.rentPercentRange',
  'Цена за сутки вне допустимого диапазона': 'srvError.rentPriceRange',
  'Неверная цена аренды': 'srvError.rentBadPrice',
  'Неверный процент': 'srvError.rentBadPercent',
  'Неверный срок аренды': 'srvError.rentBadDays',
  'Неверный срок': 'srvError.rentBadTerm',
  // автоподбор амуниции
  'Некуда снять прежнюю амуницию: инвентарь и сундук полны': 'srvError.nowhereToUnequip',
  'У игрока нет фигур этой фракции': 'srvError.noFractionUnits',
  'Фигура не найдена': 'srvError.unitNotFound',
  'Неизвестная фракция': 'srvError.unknownFraction',
  // рынок и состояние фигуры (продажа амуниции)
  'Фигура мертва — амуниция заблокирована до оживления': 'srvError.unitDeadAmmo',
  'Фигура ранена — сначала вылечите её': 'srvError.unitWounded',
  'Сначала снимите амуницию с фигуры, затем выставляйте': 'srvError.unequipFirst',
  // колесо фортуны
  'Нет билетов': 'srvError.noTickets',
  'Недостаточно энергии': 'srvError.noEnergy',
  'Слишком много билетов за раз': 'srvError.tooManyTickets',
  'Некорректное количество билетов': 'srvError.badTicketCount',
  'Неизвестный сектор колеса': 'srvError.unknownSector',
  'Пользователь не найден': 'srvError.userNotFound',
  // турниры
  'Сезон не найден': 'srvError.seasonNotFound',
  'Регистрация в этот сезон сейчас закрыта': 'srvError.seasonRegClosed',
  'В турнире не осталось свободных мест': 'srvError.seasonFull',
  'Вы уже участвуете в другом активном сезоне': 'srvError.seasonOther',
  'Вы не участвуете в этом сезоне': 'srvError.seasonNotIn',
  'Вы не участвовали в этом турнире': 'srvError.seasonNotPlayed',
  'Действие доступно только с основного аккаунта': 'srvError.mainAccountOnly',
  'Не удалось зарегистрироваться, повторите попытку': 'srvError.seasonJoinRetry',
  'Перенос доступен только после завершения турнира (окно переноса)': 'srvError.transferWindow',
  // молот кузнеца и мульти-разбор
  'Нет молота кузнеца': 'srvError.noHammer',
  'Не выбрано ни одного предмета': 'srvError.nothingPicked',
  // общие гарды вне партии
  'Ускорение недоступно во время партии': 'srvError.boostInMatch',
  'Лечение/оживление недоступно во время партии': 'srvError.careInMatch',
  'Нельзя менять амуницию во время партии': 'srvError.ammoInMatch',
  // кошелёк TON (web3, `BackEnd/apps/web3/service.py`)
  'Этот кошелёк уже привязан к другому игроку': 'srvError.walletTaken',
  'Код привязки истёк — начните подключение заново': 'srvError.walletPayloadGone',
  'Сначала привяжите кошелёк TON': 'srvError.walletNeeded',
  'Некого вернуть в состав вместо NFT-фигуры — сначала верните свою фигуру этого класса':
    'srvError.noStockToReturn',
  // запекание комплекта NFT (`BackEnd/apps/web3/baking.py`, `apps/ammo/inventory.py`)
  'Комплект запечён на NFT — сначала разблокируйте фигуру': 'srvError.bakedFrozen',
  'На фигуре нет амуниции — запекать нечего': 'srvError.bakeNothing',
  'Комплект этой фигуры уже запечён': 'srvError.bakeAlready',
  'Комплект этой фигуры не запечён': 'srvError.bakeNotBaked',
  'Не хватает энергии в балансе': 'srvError.noBalanceEnergy',
  'Это не NFT-воин': 'srvError.notNftUnit',
  'Часть комплекта выставлена на Рынок — снимите с продажи': 'srvError.bakeOnMarket',
  'Нельзя обменять амуницию: часть комплекта запечена на NFT — сначала разблокируйте фигуру':
    'srvError.swapBaked',
  // состав и запас (web3, `BackEnd/apps/units/squad.py`)
  'Эта фигура в запасе — сначала поставьте её в состав': 'srvError.unitInReserve',
  'Пройти обучение заново можно только один раз': 'srvError.tutorialRestartUsed',
  'Меняются местами фигура состава и фигура из запаса': 'srvError.swapSquadReserve',
  'Это фигуры разных фракций': 'srvError.swapOtherFraction',
  'Заменить можно только фигуру того же класса': 'srvError.swapOtherClass',
  'Сначала восстановите фигуру': 'srvError.unitNotReady',
  // «Настройки фигур»: экипировка, инвентарь, сундук, перезарядка, передача в партии
  'Предмет не найден': 'srvError.itemNotFound',
  'Предмет выставлен на Рынок — сначала снимите с продажи': 'srvError.itemOnMarket',
  'Матч не найден': 'srvError.matchNotFound',
  'Сначала снимите предмет': 'srvError.unequipFirstItem',
  'Инвентарь фигуры полон': 'srvError.unitInvFull',
  'Предмет не подходит для этого слота': 'srvError.wrongSlot',
  'Слот занят': 'srvError.slotBusy',
  'Предмет не надет': 'srvError.itemNotEquipped',
  'Нельзя обменять амуницию: в армии есть невосстановленные фигуры — сначала вылечите/оживите их':
    'srvError.swapWounded',
  'Нельзя поменять фигуру саму с собой': 'srvError.swapSelf',
  'Менять местами можно только фигуры одного типа': 'srvError.swapSameType',
  'Некуда снять: инвентарь и сундук полны': 'srvError.nowhereUnequipShort',
  'Перезаряжаются только классовые предметы': 'srvError.rechargeClassOnly',
  'Неизвестная валюта перезарядки (energy|ether)': 'srvError.rechargeCurrency',
  'Не хватает энергии на перезарядку': 'srvError.rechargeNoEnergy',
  'Передача возможна только во время партии': 'srvError.transferInMatchOnly',
  'Предмет не в инвентаре фигуры': 'srvError.itemNotInUnitInv',
  'Нельзя передать той же фигуре': 'srvError.transferSelf',
  'Фигура не на доске': 'srvError.unitNotOnBoard',
  'Фигуры не на соседних клетках': 'srvError.unitsNotAdjacent',
  'Укажите фигуру (unit_id) или фракцию (fraction)': 'srvError.pickUnitOrFraction',
  // касса Telegram Stars (`BackEnd/apps/stars/service.py`)
  'Магазин временно недоступен': 'srvError.starsOff',
  'Telegram сейчас не отвечает, попробуйте позже': 'srvError.starsTgDown',
  'Такого товара нет': 'srvError.starsNoProduct',
  'Товар временно недоступен': 'srvError.starsBadProduct',
  'Цена товара изменилась, откройте магазин заново': 'srvError.starsPriceChanged',
  'Покупки для этого аккаунта недоступны': 'srvError.starsBlacklisted',
  'Покупки закрыты: по этому аккаунту слишком много возвратов. Напишите /paysupport': 'srvError.starsRefundBlock',
  // рынок: выставление лота, покупка, снятие, лавка
  'Расходники общие для всех турниров — торгуйте ими с основного аккаунта': 'srvError.consumablesSeason',
  'В этом турнире Рынок отключён': 'srvError.marketOffSeason',
  'Некорректная цена': 'srvError.badPrice',
  'Цена вне допустимого диапазона': 'srvError.priceRange',
  'Некорректная ресурсная цена': 'srvError.badResPrice',
  'Неизвестный ресурс в цене': 'srvError.unknownPriceRes',
  'Ценой могут быть только малые самоцветы': 'srvError.priceGemsOnly',
  'Некорректное количество ресурса': 'srvError.badResCount',
  'Количество ресурса вне диапазона': 'srvError.resCountRange',
  'Предмет уже выставлен на Рынок': 'srvError.itemAlreadyListed',
  'Неизвестный ресурс': 'srvError.unknownRes',
  'Продавать можно только малые самоцветы': 'srvError.sellGemsOnly',
  'Количество должно быть ≥ 1': 'srvError.countMin1',
  'Недостаточно ресурса': 'srvError.notEnoughRes',
  'Лот не найден': 'srvError.lotNotFound',
  'Это не ваш лот': 'srvError.lotNotYours',
  'Лот уже закрыт': 'srvError.lotClosed',
  'Сундук полон — освободите место, чтобы вернуть предмет': 'srvError.chestFullReturn',
  'Лот уже продан или снят': 'srvError.lotGone',
  'Нельзя купить собственный лот': 'srvError.lotOwn',
  'Лот из другого мира недоступен (сезон/основной аккаунт)': 'srvError.lotOtherWorld',
  'Сделка заблокирована: систематическая торговля со связанным аккаунтом': 'srvError.selfTrade',
  'Недостаточно ресурсов для покупки': 'srvError.notEnoughForBuy',
  'Предмет лота недоступен': 'srvError.lotItemGone',
  'Сундук полон — освободите место для покупки': 'srvError.chestFullBuy',
  'Неизвестный товар': 'srvError.unknownGoods',
  'Товар не найден': 'srvError.goodsNotFound',
  // турниры: вход и перенос нажимает сам игрок (редактирование сезона — только админка, её не переводим)
  'Вход в турнир доступен только во время регистрации или проведения': 'srvError.seasonEnterWindow',
  'Ресурсы турнирного профиля изменились — повторите перенос': 'srvError.transferResChanged',
  'Баланс турнирного профиля изменился — повторите перенос': 'srvError.transferBalChanged',
  // обучение
  'Неизвестный обзор': 'srvError.unknownTour',
  'Неизвестный шаг обучения': 'srvError.unknownTutStep',
  'Этот шаг обучения ещё не начат': 'srvError.tutStepNotStarted',
  'Неизвестный пункт': 'srvError.unknownChecklist',
  'Пункт ещё не выполнен': 'srvError.checklistNotDone',
  'Неизвестный акт обучения': 'srvError.unknownAct',
  // колесо фортуны
  'Недостаточно ресурсов для покупки билетов': 'srvError.noResForTickets',
  'Некорректное количество вращений': 'srvError.badSpins',
  'Билетов меньше, чем вращений': 'srvError.ticketsLessThanSpins',
  // лечение и оживление
  'Недостаточно ресурсов': 'srvError.notEnoughResources',
  'Нет буста полного исцеления': 'srvError.noHospital',
  // регистрация
  'Имя может содержать буквы, цифры, пробел, дефис, точку и подчёркивание': 'srvError.nameChars',
  // партия
  'Матч уже завершён': 'srvError.matchFinished',
  // 🔴 ОТКАЗЫ САМОЙ ПАРТИИ (сокет `error`, 2026-08-14). Раньше их вообще никто не показывал — экран
  // молча писал в консоль, поэтому и переводить было нечего. Теперь в `/play-web` есть плашка отказа,
  // и без этих строк EN-игрок увидел бы кириллицу. Часть сообщений сервер шлёт ПО-АНГЛИЙСКИ (исторически)
  // — их тоже переводим, иначе в русской локали остаётся английский текст.
  "Another fraction's move": 'srvError.gmOtherFraction',
  'Сейчас ходит другая фракция': 'srvError.gmOtherFraction',
  'Not your unit': 'srvError.gmNotYourUnit',
  'Это не ваша фигура': 'srvError.gmNotYourUnit',
  'Эта фигура не принадлежит игроку': 'srvError.gmNotYourUnit',
  'This match is over': 'srvError.gmMatchOver',
  'Этот матч завершён': 'srvError.gmMatchOver',
  'Это не ваша партия': 'srvError.gmNotYourMatch',
  // каст короля и мгновенное взятие: гейты, закрытые аудитом 2026-08-29
  'Эта фигура не участвует в партии': 'srvError.gmUnitNotInMatch',
  'Взятие фигуры идёт через поединок': 'srvError.gmCaptureViaFight',
  'Сессия не найдена': 'srvError.gmNoSession',
  'Партия недоступна для просмотра': 'srvError.gmNotSpectatable',
  'Идёт обслуживание — новые партии временно недоступны': 'srvError.gmMaintenance',
  'Армия не восстановлена: вылечите/оживите фигуры или дождитесь таймера': 'srvError.gmArmyNotReady',
  // ход на доске
  'Недопустимый ход': 'srvError.gmBadMove',
  'Некорректная клетка': 'srvError.gmBadCell',
  'Скорость этой фигуры равна 0': 'srvError.gmZeroSpeed',
  'Нет цели для атаки': 'srvError.gmNoAttackTarget',
  'Нет цели на доске': 'srvError.gmNoTargetOnBoard',
  'Сейчас нельзя начать бой': 'srvError.gmNoFightNow',
  // навык и способность короля
  'Навык есть только у Короля': 'srvError.gmSkillKingOnly',
  'У этого Короля нет активного навыка': 'srvError.gmKingNoSkill',
  'Классовую способность на доске применяет только Король': 'srvError.gmAbilityKingOnly',
  'Сейчас нельзя применить навык': 'srvError.gmNoSkillNow',
  'Сейчас нельзя применить способность': 'srvError.gmNoAbilityNow',
  'Навык требует цель': 'srvError.gmSkillNeedsTarget',
  'Способность требует цель': 'srvError.gmAbilityNeedsTarget',
  'Недопустимая цель навыка': 'srvError.gmBadSkillTarget',
  'Цель навыка должна быть союзной': 'srvError.gmTargetMustBeAlly',
  'Цель навыка должна быть вражеской': 'srvError.gmTargetMustBeEnemy',
  'Король и Ферзь врага невосприимчивы к магии': 'srvError.gmImmuneRoyals',
  'Цель способности вне боя': 'srvError.gmAbilityTargetOutOfFight',
  // классовые способности НА ДОСКЕ (спецификация оунера 2026-09-11: они есть у всех фигур)
  'У этой фигуры нет классовой способности': 'srvError.gmNoClassAbility',
  'Фигура под Плащом не может атаковать': 'srvError.gmCloakedCannotAttack',
  'Второй ход делает только Конь, применивший «Ускорение»': 'srvError.gmExtraTurnKnightOnly',
  // окаменение фигуры на доске (спецификация оунера 2026-09-14)
  'Фигура обездвижена: слишком мало здоровья': 'srvError.gmPetrified',
  'Эту фигуру нельзя атаковать: она под Плащом': 'srvError.gmCloakedCannotBeHit',
  'Это заклинание книге недоступно': 'srvError.gmSpellNotInBook',
  'Цель слишком далеко': 'srvError.gmTargetTooFar',
  'Цель заклинания должна быть союзной': 'srvError.gmSpellTargetAlly',
  'Цель заклинания должна быть вражеской': 'srvError.gmSpellTargetEnemy',
  // заградительная Стена на доске (решение оунера 2026-09-12)
  'Клетку перекрывает Стена': 'srvError.gmWallOnCell',
  'Стену можно поставить только на соседнюю клетку': 'srvError.gmWallFar',
  'Клетка занята фигурой': 'srvError.gmCellBusy',
  'На этой клетке уже стоит Стена': 'srvError.gmWallHere',
  'Недостаточно ресурсов для навыка': 'srvError.gmNoSkillResources',
  'Не удалось применить навык': 'srvError.gmSkillFailed',
  // поединок
  'Сейчас ход другой фигуры': 'srvError.gmOtherUnitTurn',
  'Это действие уже сделано в этом ходу': 'srvError.gmAlreadyActed',
  'Цель невидима': 'srvError.gmTargetInvisible',
  'Ваш подкласс блокирован Стеной — атакуйте Стену': 'srvError.gmWallBlocks',
  'Войну нельзя атаковать через фигуру': 'srvError.gmWarriorAttackThrough',
  'Воин не может использовать активный навык через фигуру': 'srvError.gmWarriorSkillThrough',
  // турнир: сокет отказывает во входе в партию по состоянию сезона
  'Турнир ещё не начался — партии откроются в дату старта': 'srvError.gmSeasonNotStarted',
  'Турнир завершён — итоги подведены, новые партии недоступны': 'srvError.gmSeasonOver',
  'Партии турнира сейчас недоступны': 'srvError.gmSeasonClosed',
  // классовые способности: отказы приходят из `apps/ammo/abilities.py` тем же событием `error`
  // (аудит 2026-09-13 — в английской локали игрок получал их по-русски)
  'Выберите клетку поля': 'srvError.gmAbCellNeeded',
  'Заряды способности исчерпаны': 'srvError.gmAbNoCharges',
  'Кастер вне боевого поля': 'srvError.gmAbCasterOffField',
  'Клетка занята': 'srvError.gmAbCellTaken',
  'Недопустимая цель заклинания': 'srvError.gmAbBadSpellTarget',
  'Неизвестное заклинание': 'srvError.gmAbUnknownSpell',
  'Нельзя атаковать свою Стену': 'srvError.gmAbOwnWall',
  'Способность доступна только в бою': 'srvError.gmAbFightOnly',
  'Стену можно поставить только на своей половине поля': 'srvError.gmAbWallOwnHalf',
  'Стены на поле нет': 'srvError.gmAbNoWall',
  'У фигуры нет классового предмета': 'srvError.gmAbNoClassItem',
  'У фигуры нет классовой способности': 'srvError.gmAbNoAbility',
  'Цель способности не найдена': 'srvError.gmAbTargetNotFound',
  'Эту способность нельзя применить к Стене': 'srvError.gmAbNotOnWall',
  // аренда
  'Игрок не найден': 'srvError.playerNotFound',
  'У игрока идёт партия с арендованной фигурой — удаление возможно после её завершения': 'srvError.rentDeleteInMatch',
};

// Сообщения с числом внутри — сопоставляем по шаблону, число подставляем в перевод.
const PATTERNS = [
  // аренда: числа в тексте (сколько энергии нужно, сколько суток доступно)
  [/^Не хватает энергии: нужно (\d+)$/, 'srvError.rentNeedEnergy'],
  [/^Срок аренды — от 1 до (\d+) суток$/, 'srvError.rentDaysRange'],
  [/^Для возврата нужно вернуть (\d+) энергии, у вас (\d+)$/, 'srvError.rentRecallNeedFull'],
  [/^Для возврата нужно вернуть (\d+) энергии$/, 'srvError.rentRecallNeed'],
  [/^Дневной лимит билетов \((\d+)\) исчерпан$/, 'srvError.ticketDailyLimit'],
  [/^Сегодня можно купить не больше (\d+) билетов$/, 'srvError.ticketsLeftToday'],
  [/^Нужно (\d+) билетов для участия в турнире$/, 'srvError.seasonEntryTickets'],
  [/^За раз не больше (\d+) молотов$/, 'srvError.maxHammers'],
  [/^Нужно молотов: (\d+), есть (\d+)$/, 'srvError.needHammers'],
  [/^Пароль должен быть не короче (\d+) символов$/, 'srvError.pwdShort'],
  [/^Пароль должен быть не длиннее (\d+) символов$/, 'srvError.pwdLong'],
  [/^Имя должно быть от (\d+) до (\d+) символов$/, 'srvError.nameLen'],
  [/^За раз не больше (\d+) предметов$/, 'srvError.maxItems'],
  [/^Минимум (\d+) минут \(один самоцвет\)$/, 'srvError.minMinutes'],
  [/^За раз не больше (\d+) минут$/, 'srvError.maxMinutes'],
  [/^За раз не больше (\d+) свитков$/, 'srvError.maxScrolls'],
  [/^За раз не больше (\d+) зарядов$/, 'srvError.maxCharges'],
  [/^Минимальная цена — (\d+) энергии$/, 'srvError.minPrice'],
  [/^За один раз можно крутить не больше (\d+) раз$/, 'srvError.maxSpins'],
];

// Сообщение, ВНУТРЬ которого сервер вкладывает другую свою ошибку («Встречный предмет не подходит: …»).
// Вложенную часть переводим тем же словарём — иначе половина фразы осталась бы русской.
const NESTED = [[/^Встречный предмет не подходит: (.+)$/, 'srvError.backItemBad']];

/** Перевести серверное сообщение об ошибке; незнакомое возвращаем без изменений. */
export function serverError(text) {
  if (!text) return '';
  const key = MAP[text];
  if (key) return t(key);
  for (let i = 0; i < PATTERNS.length; i += 1) {
    const found = PATTERNS[i][0].exec(text);
    if (found) return t(PATTERNS[i][1], { n: found[1], m: found[2] });
  }
  for (let i = 0; i < NESTED.length; i += 1) {
    const found = NESTED[i][0].exec(text);
    if (found) return t(NESTED[i][1], { n: serverError(found[1]) });
  }
  return text;
}

export default serverError;
